$(document).ready(function(){
    $(document).on('click', '.toggle-password', function(){
        const toggle = $(this)
        const input = toggle.prev('input')
        const icon = toggle.find('i')

        if (input.attr('type') == 'password') {
            input.attr('type', 'text')
            icon.removeClass('fa-eye-slash').addClass('fa-eye')
        } else {
            input.attr('type', 'password')
            icon.removeClass('fa-eye').addClass('fa-eye-slash')
        }
    });
});